import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
gsap.registerPlugin(CSSPlugin, CSSRulePlugin);

export default {
  init() {

    //      <------------------ site animations ------------------>

    var $windowWidth = $(window).width();

    // trigger when element is in viewport

    if ($windowWidth > 768) {

      var observerTrigger = document.querySelectorAll('.trigger');
      var staggerTrigger = document.querySelectorAll('.stagger-trigger');

      const observerOptions = {
        root: null,
        rootMargin: '-5% 0px',
        threshold: 0,
      };

      // fade in on load

      $(document).ready(function () {
        // Target element to be observed.
        const observerElement = document.querySelector('.load-trigger');

        const observer = new IntersectionObserver(
          handleIntersect,
          observerOptions
        );// Intersection Observer Callback Function
        function handleIntersect(entry) {

          // If intersecting.
          if (entry[0].intersectionRatio > 0) {

            var staggerLoadTL = gsap.timeline();

            staggerLoadTL.fromTo('.anim__fade-slide-up--stagger-load', 1, { opacity: 0, y: 50 }, { opacity: 1, y: 0, stagger: .3 });

          }
        } observer.observe(observerElement);
      });

      // fade in ------>

      const ObserverNewFadeIn = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {      // animation targets
            const fadeEl = entry.target.querySelectorAll('.anim__fade_in');

            if (entry.intersectionRatio > 0) { // Run GSAP animation tween.

              gsap.fromTo(fadeEl, 1.5, { opacity: 0 }, { opacity: 1 });

              ObserverNewFadeIn.unobserve(entry.target);
            }
          });
        },
        observerOptions
      ); observerTrigger.forEach(el => {
        ObserverNewFadeIn.observe(el);
      });

      // fade up and in ---------------------------------------------------->

      const ObserverNewSlideUp = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {      // animation targets
            const fadeSlideEl = entry.target.querySelectorAll('.anim__fade-slide-up');

            if (entry.intersectionRatio > 0) { // Run GSAP animation tween.
              var tlFadeUp = gsap.timeline();

              tlFadeUp.fromTo(fadeSlideEl, 1, { opacity: 0, y: 50 }, { opacity: 1, y: 0, stagger: .3 });

              ObserverNewSlideUp.unobserve(entry.target);
            }
          });
        },
        observerOptions
      ); observerTrigger.forEach(el => {
        ObserverNewSlideUp.observe(el);
      });

      // stagger animations ------>

      const ObserverNewStagger = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {      // animation targets
            var staggeredEl = entry.target.querySelectorAll('.anim__fade-slide-up--stagger');

            if (entry.intersectionRatio > 0) { // Run GSAP animation tween.

              var staggerTL = gsap.timeline();

              staggerTL.fromTo(staggeredEl, 1, { opacity: 0, y: 50 }, { opacity: 1, y: 0, stagger: .3 })

              ObserverNewStagger.unobserve(entry.target);
            }
          });
        },
        observerOptions
      ); staggerTrigger.forEach(el => {
        ObserverNewStagger.observe(el);
      });

    }




    $(document).ready(function () {
      // Add smooth scrolling to all links
      $('a').on('click', function (event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== '') {
          // Prevent default anchor click behavior
          event.preventDefault();

          // Store hash
          var hash = this.hash;

          // Using jQuery's animate() method to add smooth page scroll
          // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
          $('html, body').animate({
            scrollTop: $(hash).offset().top,
          }, 800, function () {

            // Add hash (#) to URL when done scrolling (default click behavior)
            window.location.hash = hash;
          });
        } // End if
      });
    });

    $('.image-slider').slick({
      autoplay: false,
      centerMode: true,
      centerPadding: '30%',
      slidesToShow: 1,
      adaptiveHeight: true,
      draggable: true,
      dots: true,
      arrows: true,
      appendDots: $('.image-slider-dots'),
      appendArrows: $('.slider-dots-inner'),
      prevArrow: $('.slider-prev'),
      nextArrow: $('.slider-next'),
      useTransform: true,
      cssEase: 'ease',

      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerMode: false,
            centerPadding: false,
            dots: true,
          },
        },
      ],
    });

    // color slider
    $('.color-slider').slick({
      autoplay: false,
      adaptiveHeight: true,
      infinite:true,
      slidesToShow: 7,
      draggable: true,
      dots: true,
      arrows: true,
      appendDots: $('.color-slider-dots'),
      appendArrows: $('.slider-dots-inner'),
      prevArrow: $('.slider-prev'),
      nextArrow: $('.slider-next'),
      useTransform: true,
      cssEase: 'ease',

      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 7,
            dots: true,
          },
        },
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 5,
            dots: true,
          },
        },
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 4,
            dots: true,
          },
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 3,
            dots: true,
          },
        },
        {
          breakpoint: 550,
          settings: {
            slidesToShow: 2,
            dots: true,
          },
        },
      ],
    });

    // sticky nav
    var fixedNav = $('.header-sticky'),
    fixedNavPosition = fixedNav.offset().top;

    $(window).on('scroll', function () {
      if ($(window).scrollTop() > fixedNavPosition) {
        $('.header-sticky').addClass('scrolled');
      } else {
        $('.header-sticky').removeClass('scrolled');
        }
    });

    // mobile menu animation
    $('.ham-btn').on('click', function () {
      $('.ham-menu-container').toggleClass('menu-open').toggleClass('ham-btn');
    });


    $('.ham-menu-container, .nav-item').on('click', function(){
      $('.header-sticky').toggleClass('no-styles');
      $('.site-nav').slideToggle(600);
    });


  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js